<template>
  <main class="shopper_notice_modal">
    <div class="modal_wrap bottom_modal" :class="{ on: show }">
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <!-- <div class="safe_modal_close" @click="$emit('close')">
            <img :src="require('@/assets/front/images/new/i_x_w.png')" alt="" />
          </div> -->
          <div class="shopper_con_pop">
            <div class="pop_content">
              <div class="info_img">
                <img
                  :src="
                    require('@/assets/front/images/v2/character/img_character_qu.png')
                  "
                  alt=""
                />
              </div>
              <div class="info_title">
                당신은 미스터리 쇼퍼인가요?
              </div>
              <div class="info_con_wrap">
                <div class="info_con con_btm">
                  <div class="con_title">미스터리 쇼퍼란?</div>
                  <div class="con_txt">
                    <div class="txt">
                      1. 일반 고객으로 가장하여
                      <span>경쟁사의 견적 확인, 신고, 비방</span> 등을 위해
                      견적을 요청하는 사람
                    </div>
                    <div class="txt">
                      2. 통신업에 종사하거나 통신업자의 의뢰를 받아
                      <span>감시, 신고, 업무방해</span> 등의 목적으로 견적을
                      요청하는 사람
                    </div>
                  </div>
                </div>
                <div class="info_con_2">
                  <div class="con_txt">
                    <div class="txt">
                      ※ 해당 행위는 업무방해죄(형법 제314조) 법 조항에 위반되는
                      명백한 위법행위이며, 퍼스 이용약관에 의거 미스터리쇼퍼로
                      의심되는 행위를 하는 사용자의 경우, 상황에 따라
                      <span
                        >회원자격 제한 또는 정지, 개인에게 직접 고발조치,
                        손해배상 청구</span
                      >를 할 수 있습니다.
                    </div>
                  </div>
                </div>
                <div class="shopperEx">
                  <button class="exTitle" @click="exViewToggle">
                    미스터리 쇼퍼 판단 기준의 예시<img
                      id="exViewBtn"
                      src="@/assets/front/images/v2/arrows/ar_hash_down.svg"
                    />
                  </button>
                  <div class="exCon" id="exCon">
                    <div>- 판매 매장으로부터 미스터리 쇼퍼 신고처리</div>
                    <div>
                      - 퍼스 관리자의 신고 내용에 대한 임의 판단 시
                      미스터리쇼퍼로 의심되는 경우
                    </div>
                  </div>
                </div>
              </div>
              <div class="sec_item">
                <label class="pnt" @click="shopperCheck">
                  <input type="checkbox" v-model="isShopper" />
                  <div class="txt"></div>
                  <div class="txt02">미스터리 쇼퍼가 아닙니다.</div>
                </label>
              </div>
            </div>
          </div>
          <div class="btm_btn">
            <div class="btn_wrap">
              <button class="btn bo" @click="$emit('close')">
                뒤로가기
              </button>
              <button class="btn" :disabled="disabled" @click="agree">
                확인
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

// Import Swiper styles
import 'swiper/swiper.scss';

// import Swiper core and required modules

import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { authMapGetters, authGetters } from '@common/store/modules';

import KeywordBenefit from '@/common/components/keyword/BenefitMini.vue';
import Reviews from '@/front/customer/views/shops/components/Reviews.vue';

import ImageModal from '@/front/customer/views/shops/modal/ImageModal';
import {
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
} from '@common/lib/common/utils';

import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';
import Vue, { nextTick } from 'vue';
export default {
  name: 'safePhoneModal',
  props: {
    show: Boolean,
  },
  components: {},
  data() {
    return {
      disabled: true,
      isShopper: false,
    };
  },
  computed: {},
  methods: {
    agree() {
      this.$emit('agree');
    },
    shopperCheck() {
      if (this.isShopper) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    exViewToggle() {
      var someElement = document.getElementById('exCon');
      console.log(someElement.classList);
      someElement.classList.toggle('on');

      console.log(someElement.querySelector('on'));

      this.$nextTick(() => {
        if (someElement.classList.contains('on')) {
          document.getElementById('exViewBtn').style.transform =
            'rotate( 180deg )';
        } else {
          document.getElementById('exViewBtn').style.transform =
            'rotate( 0deg )';
        }
      });
    },
  },
};
</script>
